<template>
  <div class="indexLayout" :class="[`locale-${currentLocale}`, { menuCollapse: menuStore.isCollapse }]">
    <div class="layoutHeader">
      <IndexHeader ref="indexHeaderRef"></IndexHeader>
    </div>
    <div class="layoutMenu">
      <el-scrollbar>
        <div class="menuWrap">
          <IndexMenu></IndexMenu>
        </div>
      </el-scrollbar>
      <div class="menuCollapseWrap">
        <MenuCollapse></MenuCollapse>
      </div>
    </div>
    <div class="layoutContent">
      <router-view v-slot="{ Component, route }">
        <keep-alive :include="keepAliveComponents">
          <component :is="Component" ref="indexRouterView"/>
        </keep-alive>
      </router-view>
    </div>
  </div>
</template>
<script setup lang="ts">
  interface TabInterface {
    name: string,
    title: string,
    path?: string
  }

  import {menu as piniaMenu} from '../pinia/menu';
  import IndexMenu from './components/layout-menu.vue';
  import IndexHeader from './components/layout-header.vue';
  import MenuCollapse from './components/menu-collapse.vue';
  import {getDictList, getDictName, classifyDict} from '../common/utils/utils';
  import store from 'storejs';
  import mqttConnect from "../common/utils/MQTT.js";

  import {toPage} from '@vUtils';

  const menuStore = piniaMenu();
  const {isCollapse} = storeToRefs(menuStore);
  const indexRouterView = ref(null);
  const indexHeaderRef = ref(null);
  const tabs: Array<TabInterface> = reactive([]);
  const route = useRoute();
  import { ElMessage } from 'element-plus';
  import { useI18n } from 'vue-i18n';

  const { t, locale } = useI18n();
  const currentLocale = computed(() => locale.value);

  const keepAliveComponents = computed(() => tabs.map(k => k.name));

  watch(
      () => route.name,
      (val) => {
        nextTick(() => {
          // @ts-ignore
          const breadcrumb = indexRouterView.value.breadcrumb;
          if (!breadcrumb || !breadcrumb.title) return;
          if (keepAliveComponents.value.includes(val as string)) return;
          if (tabs.length >= 6) tabs.shift();

          tabs.push({
            name: val,
            ...breadcrumb
          });
        });
      }
  );

  watch(() => route.path, async (path) => {
    await nextTick();
    menuStore.updateCurrentMenu(path);
  }, {
    immediate: true
  });

  // 读取字典
  const getDict = async () => {
    const {success} = await aServe.GETGetDict({});
    if (success) {
        store.set('dict', classifyDict(success));
    }else {
      console.log(success);
    }
  }

  const onMqttMessageHandle = () => {
    mqttConnect.clientMessage((topic, message) => {
        const { data, code } = JSON.parse(message);
        if (code+'' === '200') {
          if (data.subUiEvt === 'importDone') {
            console.log(data, code);
            // ElNotification({
            //   title: data.emsg,
            //   message: '批量设备已成功导入，请刷新设备列表查看！',
            //   type: 'success'
            // })
            ElMessage({
              message: t('device.batchImportSuccess'),
              type: 'success'
            })
          }
        } else {}
      })
  }

  const  updateUserInfo = async ()=>{
    const {success} = await aServe.getAccLoginAuthority({});
    if(success){
      aStore.set('userInfo', success.userInfo);
      aStore.set('mchInfo', success.mchInfo);
      // 更新用户信息后，通知 header 组件更新 showDashboardBtn
      if(indexHeaderRef.value && indexHeaderRef.value.updateShowDashboardBtn){
        indexHeaderRef.value.updateShowDashboardBtn();
      }
    }
  }



  onMounted(async ()=>{
    const sessionId = localStorage.getItem('sessionId')
    if(!sessionId){
      toPage('/login');
      return
    }
    await getDict()
    onMqttMessageHandle()
    await updateUserInfo()
  })
</script>

<style scoped lang="scss">
  $headerHeight: 60px;
  $tabHeight: 0px;
  $contentTopPad: $headerHeight + $tabHeight;
  $menuWidth: 210px;
  $menuCollapseWidth: 60px;
  $menuTransitionTime: 0.7s;

  .indexLayout {
    width: 100vw;
    height: 100vh;
    box-sizing: border-box;
    position: relative;
    padding-top: $contentTopPad;
    padding-left: $menuWidth;
    transition: padding-left $menuTransitionTime;
    background: var(--base-gray);

    .layoutHeader, .layoutMenu, .layoutTab {
      position: absolute;
      /*z-index: 1;*/
    }

    .layoutHeader {
      top: 0;
      left: $menuWidth;
      right: 0;
      height: $headerHeight;
      background: white;
      transition: left $menuTransitionTime;
    }

    .layoutTab {
      top: $headerHeight;
      left: $menuWidth;
      right: 0;
      height: $tabHeight;
      font-size: 12px;
      overflow-y: hidden;
      overflow-x: auto;
      background: white;
      color: var(--base-text);
      display: flex;
      align-items: center;
      transition: left $menuTransitionTime;

    }

    .layoutMenu {
      top: 0;
      bottom: 0;
      left: 0;
      width: $menuWidth;
      overflow-x: hidden;
      overflow-y: auto;
      transition: width $menuTransitionTime;
      background: white;

      box-shadow: 2px 0px 6px rgba(0, 0, 0, 0.1);

      .menuWrap {
        box-sizing: border-box;
        width: $menuWidth;
        padding-bottom: 43px;
      }

      .menuCollapseWrap {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        padding: 10px 16px;
        background: white;
        z-index: 1;
      }

    }

    .layoutContent {
      height: 100%;
      overflow: auto;
      color: var(--base-text);
      background-color:var( --background-color-primary);
    }

    &.menuCollapse {
      padding-left: $menuCollapseWidth;

      .layoutHeader {
        left: $menuCollapseWidth;
      }

      .layoutMenu {
        width: $menuCollapseWidth;

        .menuWrap {
          box-sizing: border-box;
          width: $menuCollapseWidth;
        }
      }

      .layoutTab {
        left: $menuCollapseWidth;
      }
    }

    &.locale-en {
      $menuWidthEn: 228px;
      padding-left: $menuWidthEn;

      .layoutHeader {
        left: $menuWidthEn;
      }

      .layoutTab {
        left: $menuWidthEn;
      }

      .layoutMenu {
        width: $menuWidthEn;

        .menuWrap {
          width: $menuWidthEn;
        }
      }

      &.menuCollapse {
        padding-left: $menuCollapseWidth;

        .layoutHeader {
          left: $menuCollapseWidth;
        }

        .layoutMenu {
          width: $menuCollapseWidth;

          .menuWrap {
            width: $menuCollapseWidth;
          }
        }

        .layoutTab {
          left: $menuCollapseWidth;
        }
      }
    }
  }
</style>
